<template>
  <div class="notification-settings">
    <h1 v-if="!isMobile">{{ $t("message.settings") }}</h1>
    <div class="gradient-divider" />
    <div class="content-wrapper">
      <div
        class="done-popup"
        :class="{ nosidebar: !sidebarVisible }"
        v-if="showCreateSuccessNoti === true"
      >
        <img src="@/assets/icon_success.png" />
        {{ $t("message.notificationHasBeenCreatedSuccessfully") }}
      </div>
      <div
        class="done-popup"
        :class="{ nosidebar: !sidebarVisible }"
        v-else-if="showEditSuccessNoti === true"
      >
        <img src="@/assets/icon_success.png" />
        {{ $t("message.notificationHasBeenUpdatedSuccessfully") }}
      </div>
      <div
        class="done-popup"
        :class="{ nosidebar: !sidebarVisible }"
        v-else-if="showDeleteSuccessNoti === true"
      >
        <img src="@/assets/icon_success.png" />
        {{ $t("message.notificationHasBeenDeletedSuccessfully") }}
      </div>
      <div class="content-grid">
        <!-- BEGIN Left-side (notification groups pane) -->
        <div
          class="notification-types"
          v-if="!isMobile || !showNotificationDetails"
        >
          <!-- General group -->
          <div class="noti-group" v-if="visibleSection[0]">
            <div class="noti-group-head" @click="$set(visibleSection, 0, false)">
              {{ $t("message.generalSettings") }}
              <svg id="gml:icon/expander-right" viewBox="0 0 24 24">
                <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
              </svg>
            </div>
            <div class="noti-group-item" :class="{ selected: selectedType === 0 }" @click="setNotiType(0)">
              <svg id="gfs:icon1/acc-info" viewBox="0 0 24 24">
                <path
                  d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16.497c-4.14 0-7.497-3.357-7.497-7.497S7.86 4.503 12 4.503 19.497 7.86 19.497 12 16.14 19.497 12 19.497zm-.747-2.7h1.494v-6.3h-1.494v6.3zm0-7.767h1.503V7.5h-1.512l.009 1.53z"
                  transform="translate(-336 -260) translate(320 208) translate(0 40) translate(16 12)"></path>
              </svg>
              {{ $t("message.accountDetails") }}
            </div>
          </div>
          <div class="noti-group-hidden" v-else>
            <div class="noti-group-head" @click="$set(visibleSection, 0, true)">
              {{ $t("message.generalSettings") }}
              <svg id="gml:icon/expander-right" viewBox="0 0 24 24">
                <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
              </svg>
            </div>
          </div>

          <div class="line noti-group-line" />

          <!-- Fleet Settings group -->
          <div class="noti-group" v-if="visibleSection[1]">
            <div class="noti-group-head" @click="$set(visibleSection, 1, false)">
              {{ $t("message.settings") }}
              <svg id="gml:icon/expander-right" viewBox="0 0 24 24">
                <path
                  d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
                />
              </svg>
            </div>
            <div
              class="noti-group-item"
              :class="{ selected: selectedType === 4 }"
              @click="setNotiType(4)"
            >
              <svg id="gfs:icon/i-manage-fleet-lg" viewBox="0 0 24 24">
                <path
                  d="M21.4 8.23a1.21 1.21 0 0 1-1.06-.84l-1.6-4.18h-8.55L8.58 7.39a1.2 1.2 0 0 1-1 .84H5.26l-1.6 4.18a1.21 1.21 0 0 1-1.06.85H2v1H2.9v6.55h1V19a2 2 0 0 0 1 .28H14a2 2 0 0 0 1-.28v1.78h1v-6.52h3a2 2 0 0 0 1-.26v1.79h1v-6.6c.134.031.272.048.41.05H22v-1l-.6-.01zM9.52 7.75l1.36-3.54h7.17l1.36 3.54c.063.17.147.331.25.48h-1.2a2.25 2.25 0 0 0-4.47 0H9.26a2.77 2.77 0 0 0 .26-.48zm7.93.48H15a1.26 1.26 0 0 1 2.46 0h-.01zM4.59 12.77L6 9.24h7.17l1.36 3.53c.069.172.156.337.26.49h-1.36a2.25 2.25 0 0 0-4.47 0H4.34a2.06 2.06 0 0 0 .25-.49zm7.84.49H10a1.25 1.25 0 0 1 1.23-1 1.26 1.26 0 0 1 1.2 1zM15 16.77v.51a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3h11v2.49zm5-5v.5a1 1 0 0 1-1 1h-2.53a1.21 1.21 0 0 1-1-.85L14.2 9.24H20v2.53zm-1 0h-2v-1h2v1zm-12.06 5h-2v-1h2v1zm7 0H12v-1h2l-.06 1z"
                />
              </svg>
              {{ $t("message.accountActivity") }}
            </div>
            <div
              class="noti-group-item"
              :class="{ selected: selectedType === 5 }"
              @click="setNotiType(5)"
            >
              <svg id="gfs:icon/i-subscription-lg" viewBox="0 0 24 24">
                <path
                  d="M8.36 16l1.14 2.65v3.85h-1v-1.09a1.64 1.64 0 0 1-.33.077L8 21.5H4.5a1.64 1.64 0 0 1-.337-.043L4 21.41v1.09H3v-3.85L4.14 16h4.22zm.14 3H4v1a.5.5 0 0 0 .41.492l.09.008H8a.5.5 0 0 0 .492-.41L8.5 20v-1zm11.9-8.903c.094.42.13 1.01.106 1.775L20.5 12a8.5 8.5 0 0 1-8.5 8.5l-.193-.002-.193-.007.045-.999a7.501 7.501 0 0 0 7.776-6.5h-.858l1.823-2.895zM7.71 17H4.79l-.42 1h3.76l-.42-1zM12 3.5c.877 0 1.736.133 2.556.391l.14.048.05.017-.183.993a7.5 7.5 0 0 0-10.061 6.89l.868-.14L4 15c-.117-.28-.216-.663-.297-1.147l.066.276A8.5 8.5 0 0 1 12 3.5zm0 8a2.4 2.4 0 0 1 2.312 1.757l.346 1.243H9.342l.346-1.243a2.406 2.406 0 0 1 2.133-1.75zm0 1l-.117.005a1.4 1.4 0 0 0-1.232 1.02l.008-.025h2.681l-.033-.102a1.4 1.4 0 0 0-1.174-.892L12 12.5zm0-4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM19.512 2v1.499l2.302.001v1h-4.346a.522.522 0 0 0-.094 1.036l.094.008h2.987a1.49 1.49 0 0 1 .143 2.974l-.143.007-.943-.001v1.293h-1V8.524H16v-1h4.455a.49.49 0 0 0 .088-.972l-.088-.008h-2.987a1.522 1.522 0 0 1-.139-3.038l.139-.006 1.044-.001V2h1z"
                />
              </svg>
              {{ $t("message.subscriptionActivity") }}
            </div>
            <div
              v-if="!$store.state.inDealerMode"
              class="noti-group-item"
              :class="{ selected: selectedType === 2 }"
              @click="setNotiType(2)"
            >
              <svg id="gfs:icon1/i-thresholds" viewBox="0 0 24 24">
                <path
                  d="M12 3C8.785 3 5.813 4.715 4.206 7.5c-1.608 2.785-1.608 6.215 0 9C5.813 19.285 8.785 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16.497c-4.14 0-7.497-3.357-7.497-7.497S7.86 4.503 12 4.503 19.497 7.86 19.497 12 16.14 19.497 12 19.497zm.747-13.5h-1.494v6.3l3.213 3.213 1.062-1.062-2.781-2.781v-5.67z">
                </path>
              </svg>
              {{ $t('message.eventThresholds') }}
            </div>
            <!-- In-Vehicle Coaching -->
            <div
              v-if="!$store.state.inDealerMode && !inEssentialsMode"
              class="noti-group-item"
              :class="{ selected: selectedType === 13 }"
              @click="setNotiType(13)"
            >
              <svg id="gfs:icon1/ivc-lg" style="width: 24px" viewBox="0 0 36 36">
                <path 
                  d="M12.228 4.5c5.095 0 7.244 2.836 8.254 7.399l.05.239 2.567 5.292a1.425 1.425 0 0 1-1.121 2.037l-.16.01-.764-.001.001 3.448a2.55 2.55 0 0 1-2.33 2.54l-.22.01-2.441-.001v4.077h-2.1v-6.176h4.541a.45.45 0 0 0 .438-.347l.012-.103v-5.548h1.784l-2.15-4.435-.085-.248c-.8-3.918-2.345-6.093-6.276-6.093-4.516 0-7.369 3.296-7.369 7.2 0 2.194.393 3.63 1.446 5.83l.39.796.162.325c1.497 3.011 2.14 5.053 2.211 8.196l.007.603h-2.1c0-2.924-.475-4.699-1.736-7.327l-.58-1.177c-1.361-2.747-1.9-4.515-1.9-7.246 0-5.001 3.72-9.3 9.469-9.3zM33.6 23.1c0 3.914-1.545 7.466-4.059 10.081l-1.485-1.485A12.408 12.408 0 0 0 31.5 23.1c0-3.524-1.465-6.707-3.818-8.972l1.484-1.486A14.507 14.507 0 0 1 33.6 23.1zm-4.5 0c0 2.671-1.042 5.1-2.742 6.9l-1.486-1.487A7.922 7.922 0 0 0 27 23.1c0-2.282-.962-4.34-2.502-5.79l1.486-1.484A10.021 10.021 0 0 1 29.1 23.1z"
                  fill-rule="evenodd"
                />
              </svg>
              {{ $t('message.inVehicleCoaching') }}
            </div>
            <div
              v-if="!$store.state.inDealerMode && !$store.state.inEssentialsMode"
              class="noti-group-item"
              :class="{ selected: selectedType === 6 }"
              @click="setNotiType(6)"
            >
              <!-- Camera Icon -->
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.4947 6.4028C3.01462 6.4028 2.58729 6.76243 2.58729 7.24769V15.7523C2.58729 16.2376 3.01462 16.5972 3.4947 16.5972H14.9769C15.4569 16.5972 15.8843 16.2376 15.8843 15.7523V7.24769C15.8843 6.76243 15.4569 6.4028 14.9769 6.4028H3.4947ZM17.4716 8.76345V7.24769C17.4716 6.02521 16.3754 5 14.9769 5H3.4947C2.09612 5 1 6.02521 1 7.24769V15.7523C1 16.9748 2.09612 18 3.4947 18H14.9769C16.3754 18 17.4716 16.9748 17.4716 15.7523V14.2366L23 16.9426V6.05744L17.4716 8.76345ZM17.4716 10.367V12.633L21.4127 14.5621V8.43795L17.4716 10.367Z" />
              </svg>
              {{ $t('message.cameras') }}
            </div>
          </div>
          <div class="noti-group-hidden" v-else>
            <div class="noti-group-head" @click="$set(visibleSection, 1, true)">
              {{ $t("message.settings") }}
              <svg id="gml:icon/expander-right" viewBox="0 0 24 24">
                <path
                  d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
                />
              </svg>
            </div>
          </div>

          <div class="line noti-group-line" />

          <!-- Feature Settings group -->
          <div class="noti-group" v-if="visibleSection[2]">
            <div id="notifications-dd" class="noti-group-head" @click="$set(visibleSection, 2, false)">
              {{ $t("message.notifications") }}
              <svg id="gml:icon/expander-right" viewBox="0 0 24 24">
                <path
                  d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
                />
              </svg>
            </div>
            <div
              v-if="!$store.state.inDealerMode"
              class="noti-group-item"
              :class="{ selected: selectedType === 1 }"
              @click="setNotiType(1)"
            >
              <svg id="gfs:icon/i-diagnostics-lg" viewBox="0 0 24 24">
                <path
                  d="M13.755 2a7.346 7.346 0 0 0-7.273 6.845h-2.51v.982h2.464c.07 1.097.38 2.165.91 3.128l-3.91 3.927c-.356.358-.547.85-.527 1.354a2.018 2.018 0 0 0 1.946 1.946h.054c.487.005.955-.185 1.3-.527l3.973-3.937A7.336 7.336 0 1 0 13.755 2zM5.518 18.955a.818.818 0 0 1-.636.245 1.027 1.027 0 0 1-.991-.99.818.818 0 0 1 .245-.637L6.4 15.309c.42.501.892.955 1.41 1.355l-2.292 2.29zm2.991-2.982A8.01 8.01 0 0 1 7.1 14.609l.827-.79c.391.502.843.954 1.346 1.345l-.764.809zm5.246-.273a6.364 6.364 0 1 1 0-12.727 6.364 6.364 0 0 1 0 12.727zm5.381-6.364c.01.164.01.328 0 .491h-2.445l-.673-1.1-2.1 4.355-1.663-4.991-.982 1.736h-2.91a4.436 4.436 0 0 1 0-.982h2.3l1.819-3.154 1.6 4.8L15.9 6.68l1.318 2.164h1.873c.024.163.04.327.045.491z"
                />
              </svg>
              {{ $t("message.diagnostics") }}
            </div>
            <div
              class="noti-group-item"
              :class="{ selected: selectedType === 8 }"
              @click="setNotiType(8)"
            >
              <svg id="gfs:icon1/i-geofence-lg" viewBox="0 0 24 24">
                <path
                  d="M13.819 7.448a2.295 2.295 0 1 0-4.59 0 2.295 2.295 0 0 0 4.59 0zm-2.295 1.276a1.276 1.276 0 1 1 0-2.553 1.276 1.276 0 0 1 0 2.553zM7.486 12.8h-2.22a.571.571 0 0 0-.552.438l-.238.848-.952-.276.238-.858a1.619 1.619 0 0 1 1.533-1.171h1.467c.219.352.467.695.724 1.019zm13.562 6.524a1.619 1.619 0 0 1-1.19 1.571l-.268-.952a.61.61 0 0 0 .439-.59.657.657 0 0 0 0-.191l-.886-3.22.952-.266.905 3.181c.038.153.054.31.048.467zm-1.524-5.61l-.953.267-.21-.743a.571.571 0 0 0-.551-.438h-2.248c.257-.324.505-.667.733-1.019h1.486c.713.01 1.336.486 1.533 1.171l.21.762zM3.048 19.143a.552.552 0 0 0 0 .18.61.61 0 0 0 .485.6l-.162 1.01a1.638 1.638 0 0 1-1.304-2.076l.885-3.086.953.277-.857 3.095zm9.523.79h5.096v1.02H12.59l-.019-1.02zm-3.81-2.038h7.249l-.953-3.571h-2.38c1.447-1.314 4.075-4.114 4.075-6.934a5.295 5.295 0 0 0-10.59 0c0 3.81 4.762 7.562 4.98 7.715l.382.228h2.857l.4 1.534H7.952l-.495 2.971v.086h-2v1.028h5.114v-1.019H8.476l.286-2.038zm2.706-3.81C10.429 13.2 7.19 10.22 7.19 7.42a4.286 4.286 0 1 1 8.572 0c.038 2.762-3.2 5.743-4.238 6.629l-.057.038z"
                ></path>
              </svg>
              {{ $t("message.geofence") }}s
            </div>
            <div
              v-if="!$store.state.inDealerMode"
              class="noti-group-item"
              :class="{ selected: selectedType === 7 }"
              @click="setNotiType(7)"
            >
              <svg id="gfs:icon1/i-driver-lg" viewBox="0 0 24 24">
                <path
                  d="M22 19.26l-3.06-5.78a4.32 4.32 0 0 0-3.86-2.28h-1a4 4 0 0 0 2.17-3.55V6.23A4.18 4.18 0 0 0 12 2.14a4.19 4.19 0 0 0-4.27 4.09v1.42A4.06 4.06 0 0 0 9.9 11.2h-1a4.34 4.34 0 0 0-3.81 2.17L2 19.26l3.17 1v-.06a6 6 0 0 1 .08-1l-1.7-.51L6 14v-.08a3.27 3.27 0 0 1 2.89-1.65h6.16A3.28 3.28 0 0 1 18 14l2.45 4.64-1.7.51c.05.331.077.665.08 1v.06l3.17-.95zM8.8 7.65V6.23a3.11 3.11 0 0 1 3.2-3 3.11 3.11 0 0 1 3.19 3v1.42a3.11 3.11 0 0 1-3.19 3 3.12 3.12 0 0 1-3.2-3zM12 14.4a5.77 5.77 0 0 0-5.63 7.04l.09.42h11.07l.09-.42c.095-.42.142-.85.14-1.28A5.76 5.76 0 0 0 12 14.4zm0 1.06a4.71 4.71 0 0 1 4.38 3H14.3a2.85 2.85 0 0 0-4.6 0H7.62a4.69 4.69 0 0 1 4.38-3zm4.65 5.33H7.34a4.44 4.44 0 0 1 0-.63 4.6 4.6 0 0 1 0-.64h2.94l.16-.26a1.78 1.78 0 0 1 3.1 0l.15.26h2.95a4.6 4.6 0 0 1 .01 1.27z"
                ></path>
              </svg>
              {{ $t("message.driverBehavior") }}
            </div>
            <div
              class="noti-group-item"
              :class="{ selected: selectedType === 3 }"
              @click="setNotiType(3)"
            >
              <svg id="gfs:icon/i-maintenance-lg" viewBox="0 0 24 24">
                <path
                  d="M17.25 3.05V2H16.2v1H7.8V2h-1v1H2.54v17.92h3.09l-.21-.54c-.06-.17-.11-.34-.16-.51H3.59V8.54c.304.18.648.28 1 .29h14.77a2.09 2.09 0 0 0 1.05-.29v11.33h-7a4.49 4.49 0 0 1-.41 1.05h8.47V3.05h-4.22zm2.11 4.73H4.64a1 1 0 0 1-1-1V4.1h3.11v1.05h1V4.1h8.4v1.05h1.05V4.1h3.16v2.63a1 1 0 0 1-1 1.05zM9.33 22a3 3 0 0 1-1.14-.22l-.6-.23L9 19.3l-.14-.15-2.22 1.45-.24-.6a3.16 3.16 0 0 1 3.34-4.27L12 13.5a3.16 3.16 0 0 1 4.27-3.34l.6.24-1.45 2.25.15.14 2.25-1.44.18.65a3.14 3.14 0 0 1-3.34 4.26l-2.23 2.23A3.14 3.14 0 0 1 9.33 22zm-.11-1a2.14 2.14 0 0 0 1.6-.61 2.09 2.09 0 0 0 .55-2l-.06-.28 3-3 .28.06a2.09 2.09 0 0 0 2-.55 2.14 2.14 0 0 0 .61-1.6l-1.8 1.16-1.35-1.38L15.2 11a2.09 2.09 0 0 0-2.15 2.56l.07.29-3 3-.29-.07A2.09 2.09 0 0 0 7.24 19L9 17.81l1.34 1.34L9.22 21z"
                />
              </svg>
              {{ $t("message.maintenanceReminder") }}
            </div>
            <div
              v-if="!$store.state.inDealerMode"
              class="noti-group-item"
              :class="{ selected: selectedType === 9 }"
              @click="setNotiType(9)"
            >
              <svg id="gfs:icon1/i-locationMasking-lg" viewBox="0 0 24 24">
                <path
                  d="M17.38 20l1.23 1H5.37l1.25-1h10.76zm3.77-4a.86.86 0 01.85.86v1.83c0 .336-.155.653-.42.86L20 20.81l-1.59-1.26a1.108 1.108 0 01-.41-.86v-1.83a.86.86 0 01.85-.86h2.3zm-16 0a.86.86 0 01.85.86v1.83c0 .336-.155.653-.42.86L4 20.81l-1.59-1.26a1.108 1.108 0 01-.41-.86v-1.83a.86.86 0 01.85-.86h2.3zM21 17h-2v1.69a.085.085 0 000 .07l1 .78 1-.77a.087.087 0 000-.08V17zM5 17H3v1.69a.085.085 0 000 .07l1 .78 1-.77a.087.087 0 000-.08V17zM18.123 3.244l.696.697-1.833 1.834c.33.729.514 1.542.514 2.398 0 2.014-1.62 4.613-4.832 7.865l-.316.317-.352.35-.668-.667c-.84-.85-1.57-1.656-2.192-2.418l-1.699 1.7-.696-.697L18.123 3.244zm-1.905 3.298l-1.733 1.736a2.5 2.5 0 01-2.207 2.207l-2.427 2.423c.452.56.97 1.149 1.554 1.767l.358.374.236.241.518-.533c2.48-2.609 3.795-4.707 3.964-6.25l.014-.17.005-.164c0-.574-.1-1.123-.282-1.63zM12 2.5c1.496 0 2.85.615 3.84 1.612l-.706.708A4.404 4.404 0 0012 3.5c-2.481 0-4.5 2.089-4.5 4.673 0 .85.388 1.891 1.168 3.112l-.723.722C6.983 10.547 6.5 9.273 6.5 8.173 6.5 5.043 8.959 2.5 12 2.5zm0 3c.678 0 1.294.27 1.744.709l-.706.708a1.5 1.5 0 00-2.121 2.121l-.708.706A2.5 2.5 0 0112 5.5z">
                </path>
              </svg>
              {{ $t('message.locationMasking') }}
            </div>
            <div
              v-if="!$store.state.inDealerMode"
              class="noti-group-item"
              :class="{ selected: selectedType === 10 }"
              @click="setNotiType(10)"
            >
              <svg id="gfs:icon1/i-vehicleUnreachable-lg" viewBox="0 0 24 24">
                <path
                  d="M16.017 9.555l.238.628.005-.003 1.13 3c.086.22.282.375.51.412l.1.008h1v1h-.73l.73 1v6h-3.5v-2.5h-7v2.5H5v-6l.73-1H5v-1h1c.243.006.466-.122.585-.327l.045-.093 1.13-3h.002L8 9.555h8.017zM6 18.95v1.65h1.5v-1.5h-.8c-.242.002-.48-.049-.7-.15zm12 0c-.175.081-.364.13-.555.145l-.145.005h-.8v1.5H18v-1.65zm-1.35-4.35h-9.3c-.198 0-.385.082-.518.224l-.062.076-.77 1v1.56c.01.175.09.339.221.455.105.093.237.15.375.163l.104.002h10.6c.175.01.347-.048.479-.165.105-.093.177-.216.207-.352L18 17.46v-1.58l-.77-1c-.137-.18-.353-.285-.58-.28zM9 16.1v1H7v-1h2zm8 0v1h-2v-1h2zm-1.645-5.585H8.662l-.112.295-1 2.72.003.035-.003.035h8.92l-.003-.035.003-.035-.943-2.565-.172-.45zM12.045 5v.792l-1.403 1.735-.36.281h1.764V8.6H9.223v-.792l1.419-1.706.367-.31H9.223V5h2.823zm4-3v.792l-1.403 1.735-.36.281h1.764V5.6h-2.823v-.792l1.419-1.706.367-.31h-1.786V2h2.823z">
                </path>
              </svg>
              {{ $t('message.vehicleUtilization') }}
            </div>
            <div
              v-if="!$store.state.inDealerMode"
              class="noti-group-item"
              :class="{ selected: selectedType === 11 }"
              @click="setNotiType(11)"
            >
              <svg id="gfs:icon1/i-offHours-lg" viewBox="0 0 24 24">
                <path
                  d="M6.164 3.5h11.672L19.4 7.343c.155.363.493.609.883.65l.132.007H22v1l-1.694-.002 1.194 1.71v3.453c-.47-.481-1.026-.877-1.645-1.162L20.5 13v-1.978L19.39 9.43c-.187-.269-.494-.43-.82-.43H5.43c-.326 0-.633.161-.82.431L3.5 11.022V13h1.586c.132 0 .26-.053.353-.146l1.415-1.415c.28-.281.662-.439 1.06-.439h8.172c.398 0 .78.158 1.06.44l1.103 1.103c-.225-.029-.455-.043-.688-.043-.244 0-.485.016-.72.047l-.402-.4c-.093-.094-.22-.147-.353-.147H7.914c-.132 0-.26.053-.353.146L6.206 13.5h8.193c-.403.284-.767.62-1.08 1H4.742c-.16 0-.321-.02-.477-.058l-.155-.045-.611-.203V15c0 .552.448 1 1 1h7.937c-.125.319-.221.653-.285 1H6.5v3h-4v-9.292l1.194-1.712L3.58 9H2V8h1.586c.394.005.757-.205.949-.535l.057-.114L6.164 3.5zM17.5 13.528c2.485 0 4.5 2.014 4.5 4.5 0 .707-.163 1.377-.454 1.973h-8.092c-.29-.596-.454-1.266-.454-1.973 0-2.486 2.015-4.5 4.5-4.5zm-14 3.204V19h2v-2h-1c-.364 0-.706-.097-1-.268zm14-2.204c-1.933 0-3.5 1.567-3.5 3.5 0 .308.04.61.117.901l.02.071h2.503c-.108-.159-.171-.351-.171-.558 0-.553.448-1 1-1 .098 0 .193.014.282.04l1.844-1.46c.043-.035.106-.027.14.016.028.036.029.086.001.122l-1.379 1.822c.072.137.112.294.112.46 0 .207-.063.399-.17.559L20.86 19l.022-.07c.058-.219.095-.443.11-.672l.007-.23c0-1.933-1.567-3.5-3.5-3.5zM17.164 4.5H6.836L5.515 7.737c-.04.093-.086.182-.138.266L5.43 8h6.12c.231-1.14 1.24-2 2.45-2 1.21 0 2.219.86 2.45 2h2.12l.05.003-.077-.134-.066-.14L17.164 4.5zM14 7c-.653 0-1.209.418-1.415 1h2.83c-.206-.582-.762-1-1.415-1z">
                </path>
              </svg>
              {{ $t('message.offHoursViolations') }}
            </div>
            <div
              v-if="!$store.state.inDealerMode"
              class="noti-group-item"
              :class="{ selected: selectedType === 12 }"
              @click="setNotiType(12)"
            >
              <svg id="gfs:icon1/i-drivingLimit-lg" viewBox="0 0 24 24">
                <path
                  d="M17.052 12.1a4.95 4.95 0 1 1 0 9.9 4.95 4.95 0 1 1 0-9.9zm0 1.1a3.85 3.85 0 1 0 0 7.7 3.85 3.85 0 1 0 0-7.7zM12 3.52a4 4 0 0 1 3.995 3.8l.005.2v.9c.005 1.193-.507 2.314-1.38 3.1-.792.345-1.494.857-2.065 1.5H10.56l1.1 1.317c-.172.34-.313.698-.42 1.07L9.24 13h-.7a3.12 3.12 0 0 0-2.682 1.557l-.098.183-2.2 4.82h2.48l.9-2.68 1 .32-.78 2.36h4.384c.163.357.36.696.586 1.01H2l2.84-6.25a4.14 4.14 0 0 1 3.477-2.313L8.53 12h1.53a4.11 4.11 0 0 1-2.055-3.36L8 8.42v-.9a4 4 0 0 1 4-4zm5.78 11.432v2.277L16 19.088l-.792-.792 1.474-1.507v-1.837h1.1zM10.5 4.922A3 3 0 0 0 9.007 7.32L9 7.52v.9a3 3 0 0 0 5.995.176L15 8.42v-.9a3 3 0 0 0-4.5-2.598z">
                </path>
              </svg>
              {{ $t('message.drivingLimit') }}
            </div>
            <!-- <div
              v-if="!$store.state.inDealerMode"
              class="noti-group-item"
              :class="{ selected: selectedType === 9 }"
              @click="setNotiType(9)"
            >
              <svg
                id="gfs:icon1/ivc"
                viewBox="0 0 24 24"
                width="100%"
                height="100%"
              >
                <path
                  d="M19.45 8.43a9.67 9.67 0 01.24 13.7l-.99-1a8.27 8.27 0 00-.25-11.71l1-1zm-2.13 2.12a6.68 6.68 0 01.25 9.45l-.99-.99a5.29 5.29 0 00-.25-7.47l1-.99zM8.15 3c3.4 0 4.83 1.89 5.5 4.93l.04.16 1.71 3.53a.95.95 0 01-.75 1.36h-.61v2.3a1.7 1.7 0 01-1.56 1.7h-1.77v2.72H9.3v-4.12h3.03a.3.3 0 00.29-.23v-3.77h1.2l-1.44-2.95-.05-.17C11.8 5.85 10.77 4.4 8.15 4.4a4.7 4.7 0 00-4.91 4.8c0 1.46.26 2.42.96 3.89l.26.53.11.21c1 2.01 1.43 3.37 1.47 5.47l.01.4h-1.4a9.9 9.9 0 00-1.16-4.88l-.38-.79A9.65 9.65 0 011.84 9.2 6.1 6.1 0 018.15 3z"
                ></path>
              </svg>
              {{ $t("message.inVehicleCoaching") }}
            </div> -->
          </div>
          <div class="noti-group-hidden" v-else>
            <div class="noti-group-head" @click="$set(visibleSection, 2, true)">
              {{ $t("message.notifications") }}
              <svg id="gml:icon/expander-right" viewBox="0 0 24 24">
                <path
                  d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
                />
              </svg>
            </div>
          </div>
        </div>
        <!-- END Left-side (notification groups pane) -->

        <!-- BEGIN Right-side (notification list/details) -->
        
        <!-- Diagnostics -->
        <!-- Geofence -->

        <!-- In-Vehicle Coaching -->
        <div
          class="notification-type-detail"
          v-if="
            selectedType === 13 && (!isMobile || showNotificationDetails)
          "
        >
          <div class="noti-detail-info">
            <h3>{{ $t("message.inVehicleCoaching") }}</h3>
            <div
              class="line"
              style="
                grid-row: 2 / 3;
                grid-column: 1 / 3;
                align-self: center;
                width: 100%;
                justify-self: center;
              "
            />
          </div>
          <IVCFleetSettings :dataset="dataset" />
        </div>

        <!-- Cameras -->
        <div
          class="notification-type-detail"
          v-if="
            selectedType === 6 && (!isMobile || showNotificationDetails)
          "
        >
          <div class="noti-detail-info">
            <h3>{{ $t("message.cameras") }}</h3>
            <div
              class="line"
              style="
                grid-row: 2 / 3;
                grid-column: 1 / 3;
                align-self: center;
                width: 100%;
                justify-self: center;
              "
            />
          </div>
          <CameraSettings :dataset="dataset" />
        </div>

        <!-- Event Thresholds (previously Driver Speeding) -->
        <div
          class="notification-type-detail"
          v-if="
            selectedType === 2 && (!isMobile || showNotificationDetails)
          "
        >
          <div
            class="noti-detail-info"
            style="border-bottom: 1px solid var(--light-grey-2); grid-template-rows: auto auto; padding-bottom: 16px; margin: 0;"
          >
            <h3>{{ $t('message.eventThresholds') }}</h3>
            <svg id="gfs:icon1/i-global" viewBox="0 0 24 24">
              <path
              fill-rule="evenodd"
              d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zM3.64 8.659l-.045-.1c.706 1.6 1.47 2.723 2.276 3.372.36.29.826.594 1.414.932l.375.212 1.159.629c.57.311.82.466.963.648l.04.056c.152.233.171.363.125.974l-.053.708c-.027.493.012.8.092.898l.339.406c.623.76.925 1.306.925 1.96 0 .446-.041.95-.123 1.516l-.014.087c.292.028.588.043.887.043.24 0 .478-.01.713-.028l1.357-3.803c.033-.092.092-.173.17-.232.733-.55 1.069-1.03 1.069-1.414 0-.613-.628-1.382-1.179-1.47l-.102-.009h-2.765c-.11 0-.215-.036-.301-.1l-.061-.055-1.102-1.159-.098-.024c-1.347-.334-2.048-.669-2.179-1.223l-.017-.1c-.092-.843.925-1.3 2.09-1.423.312-.033.566.03.857.182l.161.091-.395-.68c-.14-.25-.194-.369-.194-.543 0-.412.321-.725.97-1.14.094-.06.205-.087.315-.077l.082.014.334.088.041-.049-.034-.027c-.266-.236-.39-.558-.339-.945l.024-.13c.086-.376.278-.585.613-.78l.36-.192c.013-.01.012-.014.012-.022 0-.176-.867-1.092-2.451-2.42l-.088-.075c-2.84.692-5.154 2.732-6.222 5.404zM12 3c-.284 0-.566.013-.844.039l-.105-.09c1.607 1.378 2.351 2.224 2.351 2.8 0 .463-.194.703-.59.93l-.188.1c-.181.094-.219.129-.232.187-.028.124-.001.158.289.23.328.083.474.455.313.734l-.052.073-.655.779c-.104.123-.259.187-.416.177l-.094-.016-.424-.112-.055.04c-.069.049-.127.094-.175.136l-.047.041.118.191.3.52c.449.818.58 1.292.043 1.643-.23.15-.476.166-.723.09l-.202-.08-.057-.03-.341-.219c-.255-.166-.393-.221-.513-.208-.612.064-1.2.329-1.202.319l.43.16c.284.098.703.23 1.245.358.063.015.122.041.175.079l.073.063 1.056 1.11h2.55c1.113 0 2.187 1.2 2.275 2.332l.006.147c0 .715-.444 1.397-1.282 2.07l-.065.049-1.131 3.172c3.634-.751 6.466-3.693 7.056-7.383l-2.635-.6c-.117-.027-.218-.094-.289-.188l-.047-.075-1.033-2.046c-.063-.125-.07-.27-.023-.398l.045-.093 1.196-1.915c.031-.05.071-.094.117-.13l.075-.048 1.342-.705C18.045 4.69 15.22 3 12 3zm-8.79 7.061l-.027.125C3.063 10.772 3 11.38 3 12c0 4.328 3.054 7.942 7.125 8.804l-.039.25c.11-.658.164-1.225.164-1.7 0-.315-.178-.666-.573-1.17l-.126-.155c-.059-.073-.286-.344-.337-.407-.267-.325-.344-.751-.328-1.373l.015-.306.07-.943c.004-.038.008-.054.014-.045l-.426-.251-1.386-.755c-.136-.076-.262-.147-.387-.22-.629-.361-1.135-.691-1.542-1.019-.735-.592-1.41-1.475-2.033-2.649zM20.119 8.11l-1.241.651-.975 1.562.8 1.585 2.288.522c.007-.142.01-.285.01-.429 0-1.394-.317-2.713-.882-3.891z"
              ></path>
            </svg>
            <p style="grid-column: 1 / 3; max-width: 636px;">
              The below thresholds apply for Driver Behavior, In-Vehicle Coaching, or Diagnostic notifications when turned on
            </p>
          </div>

          <ModalDropdown @click="expanded = !expanded" />
          <div class="flex column">
            <div class="speed-condition-grid">
              <div style="height: 1px; background-color: var(--light-grey-2)" />
              <span class="conditions-bold">{{
                $t("message.fixedSpeed")
              }}</span>
              <div class="flex" style="align-items: center; align-self: start;">
                <span class="condition-text">
                  {{ $t("message.thresholdForFixedSpeedViolations") }}
                </span>
                <input
                  :value="
                    conversions.getMphValue(
                      $store.state.eventThresholdNotification.fixed,
                      $i18n.locale
                    )
                  "
                  type="number"
                  class="search-box"
                  style="width: 40px; margin: 0 16px"
                />
                <span class="condition-text">{{ $t("message.mph") }}</span>
              </div>
              <!-- <div style="height: 1px; background-color: var(--light-grey-2)" /> -->
              <span class="conditions-bold">{{
                $t("message.roadSpeedLimit")
              }}</span>
              <div class="flex" style="align-items: center; align-self: start;">
                <span class="condition-text">
                  {{ $t("message.thresholdForPostedRoadSpeedViolations") }}
                  <span>*</span>
                </span>
                <input
                  :value="
                    conversions.getMphValue(
                      $store.state.eventThresholdNotification.road,
                      $i18n.locale
                    )
                  "
                  class="search-box"
                  type="number"
                  style="width: 40px; margin: 0 16px"
                />
                <span class="condition-text">{{ $t("message.mph") }}</span>
              </div>
              <span class="condition-text fine-print">
                * {{ $t("message.whereAvailable") }}
              </span>
              <!-- <div style="height: 1px; background-color: var(--light-grey-2)" /> -->
              <span class="conditions-bold">{{ $t('message.excessiveIdling') }}</span>
              <div class="flex" style="align-items: center; align-self: start;">
                <span class="condition-text">
                  {{ $t('message.thresholdForExcessiveTripIdling') }}
                </span>
                <input
                  :value="$store.state.eventThresholdNotification.excessive"
                  class="search-box"
                  type="number"
                  style="width: 40px; margin: 0 16px"
                />
                <span class="condition-text">minutes</span>
              </div>
              <span class="conditions-bold">Oil Life</span>
              <div class="flex" style="align-items: center; align-self: start;">
                <span class="condition-text">
                  {{ $t('message.thresholdForOilLife') }}
                </span>
                <input
                  :value="$store.state.eventThresholdNotification.oil"
                  class="search-box"
                  type="number"
                  style="width: 40px; margin: 0 16px"
                />
                <span class="condition-text">%</span>
              </div>
              <span class="condition-text fine-print">
                {{ $t('message.oilLifeAlertsTriggeredAfterBelowThreshold') }}
              </span>
            </div>
          </div>
          <div
            class="save-speed action-button major"
            :class="{ inactive: saved }"
            @click="checkChallenge"
          >
            {{ $t("message.saveChanges") }}
          </div>
        </div>
        <!-- Driver Behavior -->
        <!-- Maintenance Reminder -->
        <!-- Account Activity -->
        <div
          class="notification-type-detail"
          v-else-if="
            selectedType === 4 && (!isMobile || showNotificationDetails)
          "
        >
          <div class="noti-detail-info">
            <h3>{{ $t("message.accountActivity") }}</h3>
            <span>
              <!-- <img src="@/assets/add.svg?external" />Add Notification -->
            </span>
            <p>
              {{ $t("message.notifiesSelectedActivities") }}
            </p>
          </div>
          <div class="check-list">
            <div class="line head-line" />
            <div class="check-item">
              <span class="head-lbl">{{ $t("message.notification") }}</span>
              <span class="head-lbl">{{ $t("message.myPreference") }}</span>
            </div>
            <div
              class="check-item"
              v-for="(item, index) of $store.state.fleetActivitySettings"
              v-show="(item.showInFleet && !$store.state.inDealerMode) || (item.showInDealer && $store.state.inDealerMode)"
              :key="index"
            >
              <div class="noti-text">
                <div class="noti-title">
                  {{ $t("message." + camelize(item.name)) }}
                </div>
                <p>{{ $t("message." + item.desc) }}</p>
              </div>
              <div class="noti-toggles">
                <img src="@/assets/notifications-24-px.svg?external" />
                <ToggleButton
                  v-model="item.inApp"
                  :width="36"
                  :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
                />
                <img src="@/assets/envelope-24-px.svg?external" />
                <ToggleButton
                  v-model="item.email"
                  :width="36"
                  :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Subscription -->
        <div
          class="notification-type-detail"
          v-else-if="
            selectedType === 5 && (!isMobile || showNotificationDetails)
          "
        >
          <div class="noti-detail-info">
            <h3>{{ $t("message.subscriptionActivity") }}</h3>
            <span>
              <!-- <img src="@/assets/add.svg?external" />Add Notification -->
            </span>
            <p>
              {{ $t("message.notifiesUpdatesAccountSubscription") }}
            </p>
          </div>
          <div class="check-list">
            <div class="line head-line" />
            <div class="check-item">
              <span class="head-lbl">{{ $t("message.notification") }}</span>
              <span class="head-lbl">{{ $t("message.myPreference") }}</span>
            </div>
            <div
              class="check-item"
              v-for="(item, index) of $store.state.subscriptionActivitySettings"
              v-show="(item.showInFleet && !$store.state.inDealerMode) || (item.showInDealer && $store.state.inDealerMode)"
              :key="'a' + index"
            >
              <div class="noti-text">
                <div class="noti-title">
                  {{ $t("message." + camelize(item.name)) }}
                </div>
                <p>{{ $t("message." + item.desc) }}</p>
              </div>
              <div class="noti-toggles">
                <img src="@/assets/notifications-24-px.svg?external" />
                <ToggleButton
                  v-model="item.inApp"
                  :width="36"
                  :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
                />
                <img src="@/assets/envelope-24-px.svg?external" />
                <ToggleButton
                  v-model="item.email"
                  :width="36"
                  :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Account Details -->
        <div
          v-else-if="
            selectedType === 0 && (!isMobile || showNotificationDetails)
          "
          class="notification-type-detail"
        >
          <div class="noti-detail-info account-details">
            <h3>{{ $t("message.accountDetails") }}</h3>

            <div class="table">
              <div class="row">
                <p class="label">{{ $t("message.name") }}</p>
                <div class="value">
                  <div class="avatar">
                    {{ $store.state.inDealerMode ? "JE" : "FO" }}
                  </div>
                  {{
                    $store.state.inDealerMode
                      ? "Motor City Motors (Jason Edwards)"
                      : "Fleet One"
                  }}
                </div>
              </div>
              <div class="row">
                <p class="label">{{ $t("message.phone") }}</p>
                <p class="value link">
                  +1 (555) 555-{{ $store.state.inDealerMode ? 5555 : 5566 }}
                </p>
              </div>
              <div class="row">
                <p class="label">{{ $t("message.businessEmail") }}</p>
                <p class="value link">
                  {{
                    $store.state.inDealerMode
                      ? "j.edwards@mcm.com"
                      : "juan.torres@osvi-industries.com"
                  }}
                </p>
              </div>
              <div class="row">
                <p class="label">{{ $t("message.businessAddress") }}</p>
                <p class="value">
                  {{
                    $store.state.inDealerMode
                      ? "300 Renassiance Center, Detroit, MI 48426"
                      : "300 Renaissance Ctr, Detroit, MI"
                  }}
                </p>
              </div>
              <div class="row">
                <p class="label">{{ $t("message.id") }}</p>
                <p class="value">
                  {{ $store.state.inDealerMode ? 1000003 : 123456 }}
                </p>
              </div>
              <div class="row">
                <p class="label">{{ $t("message.language") }}</p>
                <p class="value">{{ $t("message.englishUS") }}</p>
              </div>
              <div class="row">
                <p class="label">{{ $t("message.createdOn") }}</p>
                <p class="value">
                  {{ $store.state.inDealerMode ? getMostRecentDate(1, 1) : getMostRecentDate(12, 10) }},
                  01:48 PM
                </p>
              </div>
            </div>
            <button>{{ $t("message.editInfo") }}</button>
          </div>
        </div>
        <NotificationTypeDetail v-else-if="!isMobile || showNotificationDetails" :selectedType="selectedType" />
        <!-- END Right-side (notification list/details) -->
      </div>
    </div>
    <GuidedTourWaypoint :id="16" target="notifications-dd" :xOffset="140" :yOffset="60" :initRotation="180" forceYReverse :copyOverride="waypointCopy" />
  </div>
</template>

<script>
import { ToggleButton } from "vue-js-toggle-button";

import IVCFleetSettings from "@/components/demo/IVCFleetSettings.vue";
import NotificationTypeDetail from "@/components/demo/NotificationTypeDetail.vue";
import ModalDropdown from "@/components/demo/ModalDropdown.vue";
import { camelize } from "../../utils/camelize.js";
import * as conversions from "../../utils/conversions.js";
import GuidedTourWaypoint from "../../components/demo/GuidedTourWaypoint.vue";
import CameraSettings from "../../components/demo/CameraSettings.vue";

export default {
  data() {
    return {
      vehicleCheckIn: true,
      vehicleAdded: true,
      newMember: true,
      managerRemoved: true,
      accountChanged: true,
      payCaptured: true,
      payExpire: true,
      payConfirm: true,
      payFail: true,
      showCreateSuccessNoti: false,
      showEditSuccessNoti: false,
      showDeleteSuccessNoti: false,
      saved: true,
      bingo: false,
      expanded: false,
      camelize: camelize,
      conversions: conversions,
    };
  },
  props: {
    dataset: Object,
    isMobile: Boolean,
    sidebarVisible: Boolean,
    challenges: Array,
    activeChallenge: String,
    numIncomplete: Number,
    timeLeft: Number,
    multiplier: Number,
  },
  components: {
    ToggleButton,
    IVCFleetSettings,
    NotificationTypeDetail,
    ModalDropdown,
    GuidedTourWaypoint,
    CameraSettings
},
  methods: {
    checkChallenge() {
      this.saved = true;
      const speed = Number(this.$store.state.eventThresholdNotification.fixed);

      if (this.activeChallenge === "not-so-fast" && speed === 75) {
        this.$emit("challengeComplete", 18);
        this.$emit("pauseTimer");
        this.bingo = true;
        this.$emit("bingo");
      }
    },
    setNotiType(type) {
      this.selectedType = type;
      this.showNotificationDetails = true;
    },
    getMostRecentDate(targetMonth, targetDay) {
      const today = new Date();
      const currentYear = today.getFullYear();
      
      const target = new Date(currentYear, targetMonth - 1, targetDay);

      if (today < target) {
        target.setFullYear(currentYear - 1);
      }

      return `${target.getMonth() + 1}/${target.getDate()}/${target.getFullYear()}`;
    },
  },
  computed: {
    visibleSection() {
      return this.$store.state.visibleSection;
    },
    selectedType: {
      get() {
        return this.$store.state.selectedType;
      },
      set(value) {
        this.$store.commit("setSelectedType", value);
      },
    },
    showNotificationDetails: {
      get() {
        return this.$store.state.notiSettingsDetails;
      },
      set(value) {
        this.$store.commit("setNotiSettingsDetails", value);
      },
    },
    sumOfSpeedNotifications() {
      return (
        this.$store.state.eventThresholdNotification.road +
        this.$store.state.eventThresholdNotification.fixed
      );
    },
    inEssentialsMode() {
      return this.$store.state.inEssentialsMode;
    },
    waypointCopy() {
      if (this.inEssentialsMode) {
        return 'Explore available notifications. Account and Diagnostics notifications are available with standard content, however, all other feature notifications require an upgraded service plan.';
      }
      return '';
    }
  },
  mounted() {
    if (this.$route.params.addedNew) {
      this.showCreateSuccessNoti = true;
      setTimeout(() => {
        this.showCreateSuccessNoti = false;
      }, 2000);
    }
    if (this.$route.params.edited) {
      this.showEditSuccessNoti = true;
      setTimeout(() => {
        this.showEditSuccessNoti = false;
      }, 2000);
    }
    if (this.$route.params.deleted) {
      this.showDeleteSuccessNoti = true;
      setTimeout(() => {
        this.showDeleteSuccessNoti = false;
      }, 2000);
    }
    if (this.$route.params.type) {
      this.selectedType = this.$route.params.type;
    }
    window.scrollTo(0, 0);
  },
  watch: {
    numIncomplete: function () {
      if (this.numIncomplete === 0) {
        this.$emit("noMoreChallenges");
      }
    },
    sumOfSpeedNotifications() {
      this.saved = false;
    },
  },
};
</script>

<style scoped lang="scss">
.content-wrapper {
  margin: 0 72px;
}
h1 {
  text-align: center;
}
.info {
  color: var(--dark-grey);
  margin-left: 16px;
}
.info-bold {
  color: var(--blue);
  font-weight: 700;
}
.content-grid {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 278px auto;
  grid-gap: 1px;
  background-color: var(--light-grey-2);
  /* border-top: 1px solid var(--light-grey-2); */
  min-height: 494px;
  margin: 22px 0;
  @media screen and (max-width: 1112px) {
    background: red;
  }
}
.notification-types {
  background-color: var(--white);
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(32px, max-content) 1px minmax(32px, max-content) 1px minmax(32px, max-content);
  gap: 4px;
  padding-top: 6px;
}
.noti-group {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 45px repeat(auto-fit, 48px);
}
.noti-group-head {
  width: 100%;
  height: 100%;
  min-height: 45px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-left: 6px;
  font-weight: 700;
  font-size: 14px;
  color: #606164;
}
.noti-group-head svg {
  width: 20px;
  height: 20px;
  transform: rotate(90deg);
  margin: 0 18px 0 6px;
  fill: #606164;
}
.noti-group-hidden .noti-group-head svg {
  transform: unset;
}
.noti-group-item {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  font-weight: 700;
  cursor: pointer;
  color: #606164;
}
.noti-group-item.selected {
  background-color: #e5edfc;
  color: var(--blue);
}
.noti-group-item svg {
  width: 24px;
  height: 24px;
  margin: 0 16px;
  // fill: var(--dark);
  fill: #606164;
}
.noti-group-item.selected svg {
  fill: var(--blue);
}
.notification-type-detail {
  background-color: var(--white);
  position: relative;
  padding-left: 20px;
}
.noti-detail-info {
  margin: 8px 0;
  margin-right: 0;
  display: grid;
  /* align-items: center; */
  grid-template-rows: auto 38px;
  /* grid-template-columns: 125px 162px; */
  grid-template-columns: 1fr 133px;
  margin-bottom: 16px;
  column-gap: 8px;
  @media screen and (max-width: 1112px) {
    align-items: center;
  }
}
.noti-detail-info h3 {
  margin: 0;
  margin-top: 16px;
}
.noti-detail-info p {
  margin: 0;
  margin-top: 10px;
  color: var(--dark-grey);
  grid-column: 1 / 3;
  line-height: 19px;
}
.noti-detail-info svg {
  width: 21px;
  height: 21px;
  align-self: flex-end;
  margin-left: auto;
}
// .noti-item-list {
//   margin: 56px 20px 0 20px;
//   display: grid;
//   grid-template-columns: 1fr;
//   grid-template-rows: repeat(auto-fill, 91px);
// }
// .noti-item {
//   display: grid;
//   height: 51px;
//   grid-template-rows: 19px 30px;
//   /* grid-template-columns: 240px 28px; */
//   grid-template-columns: 1fr 28px;
//   grid-auto-flow: column;
//   grid-gap: 2px;
//   margin-bottom: 40px;
// }
.noti-item p,
.check-item p {
  margin: 0;
  margin-top: 10px;
  font-size: 15px;
  line-height: 19px;
  color: var(--dark);
}
.noti-text {
  position: relative;
}
.noti-text.clickable {
  cursor: pointer;
  border-right: 1px solid var(--light-grey);
  margin-right: 4px;
  margin-top: -6px;
  margin-bottom: -6px;
  padding: 6px 0;
}
.noti-text.clickable p {
  color: var(--dark-grey);
  font-size: 12px;
}
.noti-text.clickable svg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 12px;
}
.noti-text.clickable p svg {
  position: unset;
  transform: unset;
  margin: 0 1px -5px 1px;
  width: 18px;
  height: 18px;
  fill: var(--dark-grey);
}
.check-item .noti-title {
  font-weight: 600;
}
.noti-item .noti-title {
  font-weight: 700;
}
// .noti-item .edit {
//   grid-row: 1 / 3;
//   align-self: center;
//   font-weight: 700;
//   color: var(--blue);
//   cursor: pointer;
// }
.line {
  width: calc(100% + 36px);
  height: 1px;
  background-color: var(--light-grey-2);
  margin: 0 -18px;
}
.noti-group-line {
  width: 100%;
  margin: 0;
  justify-self: flex-end;
}
.speed-condition-grid {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 10px 30px 50px 30px 60px 50px 30px 50px 30px 50px 50px;
  align-items: center;
  margin-top: 20px;
  padding-bottom: 40px;
}
.conditions-bold {
  font-weight: 600;
}
.condition-text {
  color: #1a1c1e;
  font-size: 15px;
}
.fine-print {
  font-size: 12px;
  color: #76777a;
  align-self: start;
}
.search-box {
  width: 95%;
  max-width: 95%;
}
.action-button.major {
  width: 192px;
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid var(--blue);
  background-color: var(--blue);
  color: var(--white);
  margin-top: 32px;
}
.action-button.save-speed {
  width: 130px;
  position: absolute;
  bottom: 0;
  right: 0;
  font-weight: 500;
}
.action-button.save-speed.inactive {
  background-color: var(--pale-grey);
  border-color: var(--pale-grey);
  color: var(--grey);
  cursor: default;
}
.noti-detail-info .add-btn {
  width: 130px;
  height: 25px;
  min-height: unset;
  grid-row: 1 / 3;
  grid-column: 2 / 3;
  margin: unset;
  /* align-self: flex-end; */
  align-self: center;
  justify-self: flex-end;
}
.noti-detail-info .add-btn .text {
  font-weight: 600;
}
@media screen and (max-width: 1030px) {
  .noti-detail-info .add-btn {
    grid-row: 1 / 2;
    /* align-self: center; */
  }
  .noti-detail-info p {
    grid-column: 1 / 3;
  }
  .noti-detail-info h3 {
    margin-top: 0;
    align-self: center;
  }
}
.noti-detail-info .add-btn .plus {
  /* width: 12px;
  height: 12px; */
  font-size: 20px;
  margin-right: 11px;
  /* margin-top: 1px; */
}
@media screen and (max-width: 1112px) {
  .content-wrapper {
    margin: 0 5%;
  }
  .content-grid {
    grid-template-columns: 1fr;
    margin-top: 0;
  }
  .add-btn.action-button.major {
    width: 50px;
    height: 50px;
    position: fixed;
    bottom: 48px;
    right: 16px;
    border-radius: 50%;
  }
  .add-btn.action-button.major .plus {
    margin-right: 0;
    font-size: 30px;
  }
  .add-btn.action-button.major .text {
    display: none;
  }
  .notification-type-detail {
    padding-left: 0;
  }
}
.noresults {
  width: 100%;
  max-width: 340px;
}
.noti-toggles {
  display: grid;
  grid-template-columns: 24px 36px;
  gap: 12px;
}
.check-list {
  margin-top: 32px;
}
.check-item {
  padding: 10px 0;
  display: grid;
  grid-template-columns: auto 80px;
  grid-template-rows: auto;
  line-height: 18px;
  grid-gap: 10px;
  /* margin-left: 16px; */
  border-bottom: 1px solid #d1d6e0;
  align-items: center;
}
.check-item svg {
  width: 18px;
  cursor: pointer;
}
.check-item p {
  grid-column: 2 / 3;
}
.head-line {
  /* width: calc(100% - 16px); */
  width: 100%;
  margin-bottom: 12px;
  /* margin-left: 16px; */
  margin-left: 0;
}
.head-lbl {
  font-size: 12px;
  font-weight: 600;
  color: var(--dark-grey);
}
.done-popup {
  position: fixed;
  top: 75px;
  /* left: 288.75px; */
  left: calc(50vw - 220px);
  background-image: url("../../assets/notification_bar_success.png");
  width: 714px;
  height: 62px;
  padding-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 10px;
  z-index: 10;
  background-size: cover;
}
.done-popup.nosidebar {
  left: 50%;
  transform: translateX(-50%);
}
@media screen and (max-width: 714px) {
  .done-popup,
  .done-popup.nosidebar {
    width: calc(100% - 8px);
    left: 0;
    transform: unset;
    margin-right: 8px;
  }
}
.done-popup img {
  margin-left: 32px;
  margin-right: 8px;
  margin-bottom: 1px;
}

.noti-detail-info.account-details {
  display: flex;
  flex-direction: column;

  h3 {
    border-bottom: 1px solid var(--light-grey);
    padding-bottom: 10px;
  }
  .table {
    margin: 30px 0;
  }
  .row {
    display: flex;

    .label {
      width: 30%;
    }
    div.value {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .value {
      flex-grow: 1;
      color: #000;
      font-weight: bold;
    }
    .value.link {
      color: var(--blue);
    }
    .avatar {
      border-radius: 50%;
      background-color: var(--dark-grey);
      width: 1.5rem;
      height: 1.5rem;
      margin-right: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 2px;
      color: #fff;
      font-size: 12px;
    }
  }

  button {
    width: 25%;
    background: #fff;
    border: 1px solid var(--light-grey);
    color: var(--blue);
    font-weight: bold;
    border-radius: 0.25rem;
    padding: 5px;
  }
}

::v-deep .Dropdown {
  max-height: 30px;
  margin: 10px 0 18px 0;
  width: 50%;
  .Dropdown__top:hover {
    border-radius: 0.25rem;
    border: 1px solid var(--light-blue);
  }
  .Dropdown-top.expanded {
    .Dropdown__arrow {
      fill: var(--light-blue);
    }
  }
  .Dropdown__options {
    position: relative;
    .Dropdown__option:hover {
      background: #eaf6f9;
      color: var(--blue);
    }
  }
}
</style>
